module.exports = __webpack_public_path__ + "static/media/S3N6-5.910956c0.svg";